import { api } from './http-client';
import {
  SystemStatusResponse,
  AppVersionConfig,
  OtpFallbackConfig,
  RegistrationSecurityConfig,
  SmsProviderConfig,
  AppCheckAlertConfig,
} from '../types/system';

export const systemService = {
  getStatus: async (): Promise<SystemStatusResponse> => {
    const response = await api.request<SystemStatusResponse>({
      url: '/system/status',
      method: 'GET',
      skipAuthRedirect: true,
    });
    return response.data;
  },
  setMaintenance: async (enabled: boolean): Promise<SystemStatusResponse> => {
    const response = await api.request<SystemStatusResponse>({
      url: '/system/maintenance',
      method: 'POST',
      data: { enabled },
    });
    return response.data;
  },
  getAdminEmail: async (): Promise<{ documentNotifyEmail: string }> => {
    const response = await api.request<{ documentNotifyEmail: string }>({
      url: '/system/admin-email',
      method: 'GET',
    });
    return response.data;
  },
  setAdminEmail: async (documentNotifyEmail: string): Promise<{ documentNotifyEmail: string }> => {
    const response = await api.request<{ documentNotifyEmail: string }>({
      url: '/system/admin-email',
      method: 'PUT',
      data: { documentNotifyEmail },
    });
    return response.data;
  },
  getCvNotifyEmail: async (): Promise<{ cvNotifyEmail: string }> => {
    const response = await api.request<{ cvNotifyEmail: string }>({
      url: '/system/cv-notify-email',
      method: 'GET',
    });
    return response.data;
  },
  setCvNotifyEmail: async (cvNotifyEmail: string): Promise<{ cvNotifyEmail: string }> => {
    const response = await api.request<{ cvNotifyEmail: string }>({
      url: '/system/cv-notify-email',
      method: 'PUT',
      data: { cvNotifyEmail },
    });
    return response.data;
  },
  getAppVersionConfig: async (): Promise<AppVersionConfig> => {
    const response = await api.request<AppVersionConfig>({
      url: '/system/app-version-config',
      method: 'GET',
    });
    return response.data;
  },
  setAppVersionConfig: async (config: Partial<AppVersionConfig>): Promise<AppVersionConfig> => {
    const response = await api.request<AppVersionConfig>({
      url: '/system/app-version-config',
      method: 'PUT',
      data: config,
    });
    return response.data;
  },
  getAppCheckAlertConfig: async (): Promise<AppCheckAlertConfig> => {
    const response = await api.request<AppCheckAlertConfig>({
      url: '/system/app-check-alert-config',
      method: 'GET',
    });
    return response.data;
  },
  setAppCheckAlertConfig: async (
    config: Partial<AppCheckAlertConfig>,
  ): Promise<AppCheckAlertConfig> => {
    const response = await api.request<AppCheckAlertConfig>({
      url: '/system/app-check-alert-config',
      method: 'PUT',
      data: config,
    });
    return response.data;
  },
  getOtpFallbackConfig: async (): Promise<OtpFallbackConfig> => {
    const response = await api.request<OtpFallbackConfig>({
      url: '/system/otp-fallback-config',
      method: 'GET',
    });
    return response.data;
  },
  setOtpFallbackConfig: async (config: Partial<OtpFallbackConfig>): Promise<OtpFallbackConfig> => {
    const response = await api.request<OtpFallbackConfig>({
      url: '/system/otp-fallback-config',
      method: 'PUT',
      data: config,
    });
    return response.data;
  },
  getRegistrationSecurityConfig: async (): Promise<RegistrationSecurityConfig> => {
    const response = await api.request<RegistrationSecurityConfig>({
      url: '/system/registration-security-config',
      method: 'GET',
    });
    return response.data;
  },
  setRegistrationSecurityConfig: async (
    config: RegistrationSecurityConfig,
  ): Promise<RegistrationSecurityConfig> => {
    const response = await api.request<RegistrationSecurityConfig>({
      url: '/system/registration-security-config',
      method: 'PUT',
      data: config,
    });
    return response.data;
  },
  getSmsProviderConfig: async (): Promise<SmsProviderConfig> => {
    const response = await api.request<SmsProviderConfig>({
      url: '/system/sms-provider-config',
      method: 'GET',
    });
    return response.data;
  },
  setSmsProviderConfig: async (
    config: Pick<SmsProviderConfig, 'provider'>,
  ): Promise<SmsProviderConfig> => {
    const response = await api.request<SmsProviderConfig>({
      url: '/system/sms-provider-config',
      method: 'PUT',
      data: config,
    });
    return response.data;
  },
};
